module.exports = __webpack_public_path__ + "4c6f8fd4730bffbe086ea749de0300de.png";